import { Component } from '@angular/core';
import { NavController, NavParams, ToastController, LoadingController, ModalController } from 'ionic-angular';
import { CameraOptions, Camera } from '@ionic-native/camera';
import { Invoice, Master, Dokumen } from '@providers/index';

import { DetailImagePage, FormInvPage } from '../';

@Component({
  selector: 'page-detail-task',
  templateUrl: 'page.html'
})
export class DetailInvPage {

  rec :any= {};
  project  :any = {};
  loading  :any;
  invoice         = {};

  images     :any = [];
  images_new :any = [];
  img_url       = '';

  
  constructor(
    public  navCtrl    : NavController,
    public  navParams  : NavParams,
    private toastCtrl  : ToastController,
    public  loadingCtrl: LoadingController,
    public  modalCtrl  : ModalController,
    public  invApi     : Invoice,
    public  masterApi  : Master,
    public  dokumenApi : Dokumen,
    public  camera     : Camera
  ) {

    this.project = this.navParams.get('project');
    if(this.navParams.get('rec')!=undefined){
      this.rec = this.navParams.get('rec');
      this.getInv();
    }

    this.img_url = this.dokumenApi.file_url;
    
  }

  showLoading(){
    this.loading = this.loadingCtrl.create({
      content: 'Please wait...'
    });
    this.loading.present();
  }

  presentToast(msg){
    this.toastCtrl.create({
      message: msg,
      duration: 3000,
      position: 'top'
    }).present();
  }

  getInv(){
    let params = {
      id : this.rec.id
    }
    this.invApi.get(params).subscribe((resp:any) => {
      this.invoice = resp.data[0];
    });
  }

  viewImage(rec) {
    let profileModal = this.modalCtrl.create(DetailImagePage, { 
      url_image : this.img_url+rec.generated_name,
      detail    : rec,
      edit      : true
    });
    profileModal.present();
    console.log("Image params => ", rec);
  }

  edit() {
    this.navCtrl.push(FormInvPage, {
      project: this.project,
      rec:this.invoice
    });
  }


}



// WEBPACK FOOTER //
// ./src/pages/project_mobile/detail_inv/page.ts